import { render, staticRenderFns } from "./candidateMenu.vue?vue&type=template&id=61e82470&scoped=true&"
import script from "./candidateMenu.vue?vue&type=script&lang=js&"
export * from "./candidateMenu.vue?vue&type=script&lang=js&"
import style0 from "./candidateMenu.vue?vue&type=style&index=0&id=61e82470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e82470",
  null
  
)

export default component.exports